import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export const TicketPass = ({ ticket }) => (
    <motion.div
        initial={{ opacity: 0, y: 24, rotate: -1 }}
        animate={{ opacity: 1, y: 0, rotate: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="rounded-3xl border border-lakou-gold/30 bg-lakou-coal overflow-hidden"
        data-testid={`ticket-pass-${ticket.code}`}
    >
        <div className="pattern-zigzag px-6 py-4 border-b border-dashed border-lakou-gold/30 flex items-center justify-between">
            <span className="font-display font-black tracking-[0.2em] text-goldgrad">LAKOU</span>
            <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-lakou-sand">{ticket.event_name}</span>
        </div>
        <div className="p-6 flex flex-col sm:flex-row items-center gap-6">
            <div className="bg-lakou-cream p-3 rounded-2xl shrink-0">
                <img src={ticket.qr} alt={`QR code for ticket ${ticket.code}`} className="w-40 h-40" />
            </div>
            <div className="text-center sm:text-left">
                <div className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-lakou-gold">{ticket.category}</div>
                <div className="font-display font-bold text-xl text-lakou-cream mt-1">{ticket.attendee_name}</div>
                <div className="font-mono2 text-xs text-lakou-grey mt-2">Dec 12, 2026 · Léogâne, Haiti</div>
                <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-lakou-gold/30 px-4 py-1.5">
                    <ShieldCheck size={13} className="text-lakou-gold" />
                    <span className="font-mono2 text-xs tracking-[0.2em] text-lakou-offwhite">{ticket.code}</span>
                </div>
                <p className="mt-3 text-xs text-lakou-sand">Show this QR at the entrance. One scan per ticket.</p>
            </div>
        </div>
    </motion.div>
);
